<template>
  <div class="view-wrapper">

    <div class="content-container">
      <v-skeleton-loader 
        v-if="loading" 
        class="mx-auto mt-4" 
        type="card-avatar, article, actions" 
        max-width="800"
      ></v-skeleton-loader>

      <v-card v-else class="mx-auto mt-2 mb-4 elevation-0" max-width="900">
        
        <v-card-text class="text-center pb-2">
          <div class="text-h6 text-sm-h5 font-weight-bold primary--text">
            {{ dadosProduto.nome }}
          </div>
          <div class="text-caption grey--text mt-1">
            Cód: {{ dadosProduto.codigo }}
          </div>
        </v-card-text>

        <div v-if="dadosProduto.imagens && dadosProduto.imagens.length > 0">
          <v-carousel
            v-model="slide"
            height="400"
            hide-delimiters
            show-arrows-on-hover
            class="elevation-1 rounded"
          >
            <v-carousel-item v-for="(imagem, i) in dadosProduto.imagens" :key="i">
              <v-sheet
                height="100%"
                color="white"
                class="d-flex align-center justify-center cursor-zoom"
                @click="abrirZoom"
              >
                <img 
                  :src="imagem.url" 
                  class="imagem-produto-main" 
                  alt="Imagem do Produto"
                />
              </v-sheet>
            </v-carousel-item>
          </v-carousel>

          <v-sheet class="mx-auto mt-3" max-width="100%">
            <v-slide-group v-model="slide" class="pa-1" center-active show-arrows>
              <v-slide-item
                v-for="(imagem, i) in dadosProduto.imagens"
                :key="`thumb-${i}`"
                v-slot="{ active, toggle }"
              >
                <v-card
                  :class="active ? 'borda-ativa' : 'borda-inativa'"
                  class="ma-2 rounded"
                  height="60"
                  width="80"
                  img
                  flat
                  @click="toggle"
                >
                  <v-img
                    :src="imagem.url"
                    height="100%"
                    width="100%"
                    cover
                  ></v-img>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </div>

        <div v-else>
          <v-sheet
            height="300"
            class="d-flex flex-column align-center justify-center text-center pa-4 grey lighten-5 rounded"
          >
            <v-icon size="64" color="grey lighten-2">mdi-image-off-outline</v-icon>
            <div class="subtitle-1 grey--text mt-2">Nenhuma imagem disponível</div>
          </v-sheet>
        </div>

        <v-divider class="my-6"></v-divider>

        <div class="px-4 pb-6">
          <div class="text-subtitle-1 font-weight-bold mb-3">
            <v-icon left color="primary">mdi-text-box-search-outline</v-icon>
            Descrição Técnica
          </div>
          
          <div v-if="dadosProduto.detalheHtml" class="detalhe-produto-html" v-html="dadosProduto.detalheHtml"></div>
          <div v-else class="text-body-2 grey--text font-italic">
            Nenhuma descrição detalhada informada.
          </div>
        </div>

      </v-card>
    </div>

    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
      <v-card class="black d-flex flex-column">
        <v-toolbar dark color="black" dense flat>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-carousel v-model="slideZoom" hide-delimiters class="flex-grow-1" :show-arrows="false">
          <v-carousel-item v-for="(imagem, i) in dadosProduto.imagens" :key="`zoom-${i}`">
            <div class="d-flex align-center justify-center fill-height">
              <v-img
                :src="imagem.url"
                contain
                max-height="90vh"
                max-width="100vw"
              ></v-img>
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from '@/plugins/dexie';

export default {
  name: 'ViewDetalhesProduto',
  props: ['produto'], 

  data() {
    return {
      loading: true,
      slide: 0,
      slideZoom: 0,
      dialog: false,
      dadosProduto: {
        nome: '',
        codigo: '',
        imagens: [],
        detalheHtml: '',
      },
    };
  },

  watch: {
    slide(val) {
      this.slideZoom = val;
    },
    '$route.query.produtoId': function(newId) {
      if (newId) this.carregarDetalhes(parseInt(newId));
    }
  },

  created() {
    const { produtoId, produtoCodigo, idCortamanhofinal } = this.$route.query;

    const idBusca = produtoId ? parseInt(produtoId) : (idCortamanhofinal ? parseInt(idCortamanhofinal) : null);
    const codigoBusca = produtoCodigo;

    if (idBusca) {
      this.carregarDetalhes(idBusca, null);
    } else if (codigoBusca) {
      this.carregarDetalhes(null, codigoBusca);
    } else {
      this.$router.back();
    }
  },

  methods: {

    async carregarDetalhes(id, codigo) {
      this.loading = true;
      this.dadosProduto.imagens = [];

      try {
        let produtoDB;
        if (id) {
            produtoDB = await db.produto
                .filter(p => p.idCortamanhofinal == id || p.idcortamanhofinal == id)
                .first();
                
            if (!produtoDB) {
                produtoDB = await db.produto
                    .filter(p => p.idproduto == id)
                    .first();
            }
        } else if (codigo) {
            produtoDB = await db.produto
                .filter(p => p.idcortamanhofinal == codigo || p.idCortamanhofinal == codigo)
                .first();
        }

        if (produtoDB) {

          this.dadosProduto.nome = produtoDB.descricao || produtoDB.Descricao || 'Sem Descrição';

          this.dadosProduto.codigo = produtoDB.idcortamanhofinal || produtoDB.idCortamanhofinal || produtoDB.idproduto; 
          
          this.dadosProduto.detalheHtml = produtoDB.detalheproduto || produtoDB.detalheHtml || '';

          const idParaBusca = Number(produtoDB.idCortamanhofinal || produtoDB.idcortamanhofinal);
          let imgRecord = null;
          if (db.imagem) {
            const idCtf = produtoDB.idcortamanhofinal || produtoDB.idCortamanhofinal;
            if (idCtf) {
              const idCtfNum = Number(idCtf);
              if (!isNaN(idCtfNum)) {
                imgRecord = await db.imagem.where('idcortamanhofinal').equals(idCtfNum).first();
              }
              if (!imgRecord) {
                imgRecord = await db.imagem.where('idcortamanhofinal').equals(String(idCtf)).first();
              }
            }
          }

          console.log('carregarDetalhes: imgRecord encontrado:', imgRecord);

          for (let i = 1; i <= 10; i++) {
            const blobLocal = imgRecord ? (imgRecord[`imgBlob${i}`] || imgRecord[`ImgBlob${i}`]) : null;
            console.log(`Imagem ${i} local blob:`, blobLocal);
            
            if (blobLocal) {
                try {
                    const urlBlob = URL.createObjectURL(blobLocal);
                    console.log(`Imagem ${i} local URL gerada:`, urlBlob);
                    this.dadosProduto.imagens.push({ url: urlBlob, index: i });
                    continue; 
                } catch (e) {
                    console.warn(`Erro blob local ${i}`, e);
                }
            }

            const caminho = produtoDB[`imagem${i}`] || produtoDB[`Imagem${i}`];
            console.log(`Imagem ${i} caminho online:`, caminho);
            
            if (caminho && caminho.length > 5) {
                  if (typeof this.fetchImagem === 'function') {
                    try {
                        const blob = await this.fetchImagem({ id: idParaBusca, indice: i });
                        console.log(`Imagem ${i} resultado fetchImagem online:`, blob);
                        if (blob) {
                            const blobParaSalvar = (blob instanceof Blob) ? blob : new Blob([blob], { type: 'image/jpeg' });
                            const urlCriada = URL.createObjectURL(blobParaSalvar);
                            console.log(`Imagem ${i} online URL gerada:`, urlCriada);
                            this.dadosProduto.imagens.push({ url: urlCriada, index: i });
                        }
                    } catch (err) {
                        console.warn(`Erro ao baixar imagem ${i}`, err);
                    }
                } else {
                    console.warn("Método fetchImagem não definido no componente!");
                }
            }
          }

        } else {
          console.error('Produto não encontrado no Dexie para o ID:', id);
          this.dadosProduto.nome = 'Produto não encontrado';
        }

      } catch (error) {
        console.error("Erro geral ao carregar detalhes:", error);
      } finally {
        this.loading = false;
      }
    },

    abrirZoom() {
      this.slideZoom = this.slide;
      this.dialog = true;
    },

    voltar() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.view-wrapper {
  background-color: white;
  min-height: 100vh;
}
.content-container {
  padding-bottom: 20px;
}
.cursor-zoom {
  cursor: zoom-in;
}

.imagem-produto-main {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.borda-ativa {
  border: 2px solid #1976D2;
  opacity: 1;
}
.borda-inativa {
  border: 2px solid transparent;
  opacity: 0.6;
}
.borda-inativa:hover {
  opacity: 1;
}

/* Estilos para o HTML que vem do banco (v-html) */
.detalhe-produto-html {
  line-height: 1.6;
  font-size: 0.95rem;
  color: rgba(0,0,0,0.87);
}
.detalhe-produto-html >>> p {
  margin-bottom: 12px;
}
.detalhe-produto-html >>> b, .detalhe-produto-html >>> strong {
  font-weight: 600;
}
.detalhe-produto-html >>> ul {
  padding-left: 20px;
  margin-bottom: 12px;
}
.detalhe-produto-html >>> li {
  margin-bottom: 4px;
}
.detalhe-produto-html >>> img {
  max-width: 100%; /* Garante que imagens dentro do HTML não estourem a tela */
  height: auto;
}
</style>